import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaletteMode } from '@mui/material';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface UiState {
  sidebarOpen: boolean;
  sidebarCollapsed: boolean;
  language: string;
  themeMode: PaletteMode;
  breadcrumbs: BreadcrumbItem[];
  globalSearchOpen: boolean;
  /** Das Chat-Fenster des KI-Assistenten. */
  aiChatOpen: boolean;
}

const initialState: UiState = {
  sidebarOpen: true,
  sidebarCollapsed: false,
  language: localStorage.getItem('language') || 'de',
  themeMode: (localStorage.getItem('themeMode') as PaletteMode) || 'light',
  breadcrumbs: [],
  globalSearchOpen: false,
  aiChatOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen(state, action: PayloadAction<boolean>) {
      state.sidebarOpen = action.payload;
    },
    toggleSidebarCollapse(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
      localStorage.setItem('language', action.payload);
    },
    setThemeMode(state, action: PayloadAction<PaletteMode>) {
      state.themeMode = action.payload;
      localStorage.setItem('themeMode', action.payload);
    },
    toggleThemeMode(state) {
      state.themeMode = state.themeMode === 'light' ? 'dark' : 'light';
      localStorage.setItem('themeMode', state.themeMode);
    },
    setBreadcrumbs(state, action: PayloadAction<BreadcrumbItem[]>) {
      state.breadcrumbs = action.payload;
    },
    setAiChatOpen(state, action: PayloadAction<boolean>) {
      state.aiChatOpen = action.payload;
    },
    setGlobalSearchOpen(state, action: PayloadAction<boolean>) {
      state.globalSearchOpen = action.payload;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  toggleSidebarCollapse,
  setLanguage,
  setThemeMode,
  toggleThemeMode,
  setBreadcrumbs,
  setAiChatOpen,
  setGlobalSearchOpen,
} = uiSlice.actions;

export default uiSlice.reducer;
